// extracted by mini-css-extract-plugin
export var headerContainer = "header-module--headerContainer--33zwT";
export var headerTitle = "header-module--headerTitle--3AA9e";
export var heroImage = "header-module--heroImage--2jc8D";